import React, { useEffect, useRef } from 'react'
import View from './view.js'
import { useDataSubmit } from 'Simple/Data.js'

export default function Logic(props) {
  let submit = useDataSubmit({
    context: 'credit_card_capture',
    viewPath: props.viewPath,
  })
  let submitRef = useRef(submit)

  useEffect(() => {
    submitRef.current = submit
  }, [submit])

  useEffect(() => {
    submitRef.current({ type: 'bootstrap' })
  }, [])

  return <View {...props} />
}
